import { formatPrice } from 'pages/prices/utils/matrix-display';

// The per-item intelligence line for a sales-logged inquiry item. Everything
// the price-log table used to hold now travels here, human-readable, into the
// quotation workbench. Segments join with a typographic middot. The rep's own
// free-text note leads, since it is the one segment written for a human.
export interface ItemNotesInput {
  note?: string; // free text from the feedback form, optional
  price?: number | null; // as reported, no VAT math; optional since 2026-09-10
  priceUnit: string;
  currentSupplier?: string;
  brand?: string;
  reasonLabel?: string;
  ourPrice?: number; // ex VAT; only pass when > 0
  ourPriceKind?: 'CLOSED' | 'DEAL';
  ourPriceUnit?: string;
  ourPriceSupplier?: string | null;
}

export function composeItemNotes(input: ItemNotesInput): string {
  const segments: string[] = [];

  const note = input.note?.trim();
  if (note) segments.push(note);

  const via = input.currentSupplier ? ` via ${input.currentSupplier}` : '';
  if (input.price != null) segments.push(`Pays AED ${formatPrice(input.price)} / ${input.priceUnit}${via}`);
  else if (input.currentSupplier) segments.push(`buys via ${input.currentSupplier}`);

  if (input.brand) segments.push(`buys: ${input.brand}`);
  if (input.reasonLabel) segments.push(`reason: ${input.reasonLabel}`);

  if (input.ourPrice != null && input.ourPriceKind && input.ourPriceUnit) {
    const label = input.ourPriceKind === 'CLOSED' ? 'our last closed' : 'our deal';
    const ourVia = input.ourPriceSupplier ? ` via ${input.ourPriceSupplier}` : '';
    segments.push(`${label}: AED ${formatPrice(input.ourPrice)} / ${input.ourPriceUnit} (ex VAT)${ourVia}`);
  }

  return segments.join(' · ');
}
